<script setup lang="ts">
defineProps<{ freeShipping?: boolean }>()
</script>

<template>
  <NCard class="group relative overflow-hidden">
    <!-- Image wrapper -->
    <div class="relative h-auto w-full">
      <NSkeleton class="aspect-[9/10] h-full w-full flex-grow object-cover" wave shape="rect" />
    </div>

    <div class="flex flex-1 flex-col px4 py4">
      <NSkeleton />
      <div class="flex items-center justify-between">
        <template v-if="freeShipping || freeShipping != null">
          <NSkeleton class="w-1/2" pulse />
        </template>

        <Rating :rating="0" class="-ml0.5" />
      </div>

      <h3 class="line-clamp-2 h10 overflow-hidden text-context" n="sm slate5 dark:slate4">
        <NSkeleton class="w-full" pulse />
      </h3>
    </div>
  </NCard>
</template>
